import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { Restaurant } from './restaurant';
import { RestaurantMenu } from './restaurant-menu';
import { RestaurantEvent } from './restaurant-event';


@Injectable()
export class RestaurantService {
	// SG_SG_R_Esquina
        name: string = 'SG_SG_R_ThefunKitchen';
        lat: number = 1.293396;
  	lng: number = 103.853462;
  	url :string ="https://www.restaurants.sg/";
	private m_restaurant_url = 'https://www.weeloy.com/api/restaurantfullinfo';
	private m_restaurant_events_url = 'https://www.weeloy.com/api/event/widget';

	private m_headers = new Headers({'Content-Type': 'application/json'});

	constructor(private http: Http) {}

	getRestaurant(id: string): Promise<Restaurant> {
		const url = `${this.m_restaurant_url}/${id}`;
		console.log("RestaurantService getRestaurant url: " + url)
		return this.http.get(url)
			.toPromise()
		    .then(response => response.json().data.restaurantinfo as Restaurant)
		    .catch(this.handleError);
	}

	getRestaurantMenu(id: string): Promise<RestaurantMenu[]> {
		const url = `${this.m_restaurant_url}/${id}`;
		console.log("RestaurantService getRestaurantMenu url: " + url)
		return this.http.get(url)
			.toPromise()
		    .then(response => response.json().data.menu as RestaurantMenu[])
		    .catch(this.handleError);
	}

	getRestaurantEvents(id: string): Promise<RestaurantEvent[]> {
		const url = `${this.m_restaurant_events_url}/${id}`;
		console.log("RestaurantService getRestaurantEvents url: " + url)
		return this.http.get(url)
			.toPromise()
		    .then(response => response.json().data.event as RestaurantEvent[])
		    .catch(this.handleError);

		    /*
ID: "107",
name: "Happy Hour",
title: "Happy Hour",
morder: "24",
eventID: "65101969",
city: "Singapore",
price: "100",
country: "Singapore",
start: "2017-09-18",
end: "2017-09-30",
description: "Spruce up your celebratory meals with a delicious array of festive goodies, from Roasted Traditional Turkey ($128), to Honey-glazed Bone-in Ham ($220), Roasted Turkey Roulade with Truffle Mushroom Stuffing ($128), Assorted Chocolate Pralines ($15 or $28), Amara’s Christmas Gingerbread House ($58), Christmas Panettone with Dried Fruit ($18), Caramelised Christmas Apple Pie with Gingerbread Spice ($38), Christmas Stollen with Almond ($22), Amara’s Signature Chempedak Log Cake ($55), Classic Chocolate or Mango Yuzu Log Cakes ($50). * Up to 15% off festive goodies for HSBC and Citibank credit cards from 25 November – 14 December 2016. * 10% off festive goodies for selected credit cards from 25 November – 25 December 2016. * Prices are subject to 7% GST. Other terms and conditions apply.",
picture: "Happy_Hourr.jpg",
is_homepage: "0",
display: "2017-06-07",
restaurant: "SG_SG_R_TheFunKitchen",
restaurant_name: "The Fun Kitchen",
internal_path: "restaurant/singapore/the-fun-kitchen"

		    */
	}

	private handleError(error: any): Promise<any> {
		console.error('an error occured', error);
		return Promise.reject(error.message || error);
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/restaurant.service.ts